// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PasswordReset_wrapper__HXTgs","logo":"PasswordReset_logo__wq8oj","reset-button":"PasswordReset_reset-button__3oIBj","link":"PasswordReset_link__31RQW"};